
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import useTranslation from 'next-translate/useTranslation'
import { useEffect, useState } from 'react'

import { getFaq } from '@/api/other/getFaq'
import FaqSection from '@/components/faq/FaqSection'
import BaseLayout from '@/components/layouts/BaseLayout'
import Advantages from '@/components/s3-bucket/Advantages'
import Characteristics from '@/components/s3-bucket/Characteristics'
import Cost from '@/components/s3-bucket/Cost'
import MainSection from '@/components/s3-bucket/MainSection'
import Navbar from '@/components/ui/Navbar'
import { servicesSlug } from '@/res/consts'
import { NAMESPACE_S3_BUCKET } from '@/res/namespaces'
import { IFaqDetail } from '@/types/Common'

const BucketPage = () => {
  const [isSidebarOpened, setIsSidebarOpened] = useState(false)
  const [faq, setFaq] = useState<IFaqDetail[]>([])
  const toggleSidebar = () => {
    setIsSidebarOpened((prevState) => !prevState)

    return isSidebarOpened
  }
  const { t, lang } = useTranslation(NAMESPACE_S3_BUCKET)

  useEffect(() => {
    const _getFaq = async () => {
      const response = await getFaq(servicesSlug.s3, lang as string)
      setFaq(response)
    }
    _getFaq()
  }, [lang])

  return (
    <>
      <BaseLayout
        seoTitle={t('bucket_title')}
        seoDescription={t('bucket_description')}
      >
        <Navbar notShowMenuIcon toggleSidebar={toggleSidebar} />
        <div
          id="costs"
          className="mt-20 grid grid-flow-row auto-rows-auto gap-[20px] py-2 small:py-3 w-full"
        >
          <MainSection />
          <Advantages />
          <Cost />
          <Characteristics />
          <FaqSection faq_info={faq} title={'FAQ'} />
        </div>
      </BaseLayout>
    </>
  )
}

export default BucketPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/services/s3-bucket/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  